module.exports = __webpack_public_path__ + "static/media/3.555413ed.png";